import { observer } from 'mobx-react-lite';
import * as React from 'react';

import TreeFile from '@/components/shared/TreeFile';
import { TreeNodeFile } from '@/entities/Tree';
import { TreeStore } from '@/stores/local/shared/TreeStore';
import { useSidebarDocumentsStore } from '@/stores/local/sidebar/SidebarDocumentsStore';

import s from './File.module.scss';

type Props = {
  store: TreeStore;
  model: TreeNodeFile;
};

const File: React.FC<Props> = ({ store, model }) => {
  const { selectionStore } = useSidebarDocumentsStore();

  const handleClick = React.useCallback(() => {
    selectionStore.toggleNode(store);
  }, [selectionStore, store]);

  return <TreeFile className={s.root} store={store} model={model} onClick={handleClick} />;
};

export default observer(File);
